export { default as ListadoDespachosClientes } from "./Listado";
export { default as DetalleDespachoCliente } from "./Detalle";